// /home/szymon/kreator2/frontend/src/hooks/useUndoRedo.js
import { useRef, useState } from "react";

export default function useUndoRedo(initialState) {
  const [current, setCurrent] = useState(initialState);
  const historyRef = useRef([initialState]);
  const indexRef = useRef(0);

  function setNewState(newVal) {
    // Dodajemy nowy stan do historii, NIE ucinamy, co pozwala na redo.
    //console.log("[useUndoRedo] setNewState => newVal:", newVal);

    const hist = historyRef.current;
    // Ucinamy tylko wtedy, gdy indexRef jest w środku (sprawa redo)
    // Ale tutaj user chce "bez ucinania" – więc nie tniemy.
    hist.push(newVal);
    indexRef.current = hist.length - 1;
    historyRef.current = hist;
    setCurrent(newVal);

    //console.log(
     // "[useUndoRedo] setNewState => histLen:",
    //  historyRef.current.length,
     // " indexRef:",
   //   indexRef.current
  //  );
  }

  function undo() {
   // console.log("[useUndoRedo] UNDO => indexRef:", indexRef.current);
    if (indexRef.current > 0) {
      indexRef.current--;
      const val = historyRef.current[indexRef.current];
      setCurrent(val);
      //console.log("[useUndoRedo] undone => new indexRef:", indexRef.current, " val:", val);
      return val;
    }
    //console.log("[useUndoRedo] cannot undo => index=0");
    return null;
  }

  function redo() {
    console.log("[useUndoRedo] REDO => indexRef:", indexRef.current);
    if (indexRef.current < historyRef.current.length - 1) {
      indexRef.current++;
      const val = historyRef.current[indexRef.current];
      setCurrent(val);
     // console.log("[useUndoRedo] redone => new indexRef:", indexRef.current, " val:", val);
      return val;
    }
    //console.log("[useUndoRedo] cannot redo => index at end");
    return null;
  }

  function resetHistory(newVal) {
   // console.log("[useUndoRedo] resetHistory => newVal:", newVal);
    historyRef.current = [newVal];
    indexRef.current = 0;
    setCurrent(newVal);
  }

  const canUndo = indexRef.current > 0;
  const canRedo = indexRef.current < historyRef.current.length - 1;

 // console.log(
 //   "[useUndoRedo] canUndo:",
 //   canUndo,
 //   " canRedo:",
 //   canRedo,
 //   " indexRef:",
 //   indexRef.current,
  //  " histLen:",
 //   historyRef.current.length
  //);

  return [current, setNewState, undo, redo, canUndo, canRedo, resetHistory];
}
